<template>
  <v-fade-transition hide-on-leave>
    <v-layout column class="overflow-y-hidden">
      <nx-bag-loading-bar :value="loading"></nx-bag-loading-bar>

      <template v-if="current">
        <nx-bag-navigate-back :text="current.name" @click="navigateBack"></nx-bag-navigate-back>
        <nx-bag-content-list @load="loadingContents = $event"
                             @click:item="handleContentClick"
                             @click:delete="handleContentDelete"
                             :filters="contentFilters"
                             :sort="contentSort"
                             class="nx-bag__container"
                             deletable-items
                             ref="contents"
        ></nx-bag-content-list>
      </template>

      <template v-else>
        <nx-bag-tag-list @load="loadingTags = $event"
                         @click="navigateTo"
                         :filters="tagFilters"
                         class="nx-bag__container"
                         ref="tags"
        ></nx-bag-tag-list>
        <nx-bag-tag-create-button v-if="!loading"
                                  @created="appendNewTag"
        ></nx-bag-tag-create-button>
      </template>

    </v-layout>
  </v-fade-transition>
</template>

<script>
import { mapState } from 'vuex';
import NxBagNavigateBack from './components/common/BagNavigateBack';
import NxBagContentList from './components/content/BagContentList';
import NxBagTagList from './components/tag/BagTagList';
import NxBagLoadingBar from './components/common/BagLoadingBar';
import NxBagTagCreateButton from './components/tag/BagTagCreateButton';

export default {
  components: {
    NxBagNavigateBack,
    NxBagContentList,
    NxBagTagList,
    NxBagLoadingBar,
    NxBagTagCreateButton,
  },
  data() {
    return {
      loadingTags: false,
      loadingContents: false,
    };
  },
  computed: {
    ...mapState('bag/tags', [
      'current',
    ]),
    ...mapState('bag', {
      storeLoading: 'loading',
    }),
    loading() {
      return this.loadingTags || this.loadingContents || this.storeLoading;
    },
    currentTagId() {
      return this.current && this.current.id ? this.current.id : null;
    },
    tagFilters() {
      return {
        type: 'internaltag',
        parentId: this.currentTagId,
      };
    },
    contentFilters() {
      return {
        internalTag: [this.currentTagId],
      };
    },
    contentSort() {
      return { modificationDate: 'DESC' };
    },
    tagSort() {
      return { sortName: 'ASC' };
    },
  },
  methods: {
    appendNewTag(tag) {
      this.$refs.tags.appendNewTag(tag);
    },
    navigateTo(tag) {
      this.reset();
      this.$store.dispatch('bag/tags/NAVIGATE_TO', tag);
    },
    navigateBack() {
      this.reset();
      this.$store.dispatch('bag/tags/NAVIGATE_TO', null);
    },
    handleContentClick(content) {
      this.$store.dispatch('bag/ITEM_SELECTED', content);
    },
    async handleContentDelete(content) {
      await this.$store.dispatch('bag/DELETE_CONTENT', content);
      this.refreshContents();
    },
    refreshContents() {
      this.$refs.contents.refresh();
    },
    reset() {
      this.loadingTags = false;
      this.loadingContents = false;
    },
  },
  mounted() {
    this.addContentActionUnsubscribe = this.$store.subscribeAction({
      after: ({ type, payload }) => {
        if (payload
          && type === 'bag/tags/ADD_CONTENT') {
          this.refreshContents();
        }
      },
    });
  },
  beforeDestroy() {
    this.addContentActionUnsubscribe();
  },
};
</script>
